import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";
import { StyledInput } from "../../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import InputWrapper from "../../../input/wrapper/InputWrapper";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function ReferenceCheckStepView({
  controller,
  references,
  onReferenceChange,
  onReferenceAdd,
  onReferenceRemove,
}) {
  const { translate } = useLanguageContext();

  return (
    <FlowPlayerControls controller={controller}>
      <StyledFlexColumn>
        {references.map((reference, index) => (
          <StyledFlexRow key={index}>
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.reference")}
                required
                error={EVAApiHelper.getResponseError(
                  `reference.${index}`,
                  controller.errors,
                )}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.reference",
                  )}
                  value={reference}
                  onChange={(e) => onReferenceChange(e, index)}
                />
              </InputWrapper>
            </StyledFlexItem>

            {references.length > 1 && (
              <StyledAltIconButton
                title={translate("eva.main.general.clear")}
                onClick={() => onReferenceRemove(index)}
              >
                <FontAwesomeIcon icon={faXmark} />
              </StyledAltIconButton>
            )}
          </StyledFlexRow>
        ))}

        <StyledAltIconButton
          title={translate("eva.main.general.add")}
          onClick={onReferenceAdd}
        >
          <FontAwesomeIcon icon={faPlus} />
        </StyledAltIconButton>
      </StyledFlexColumn>
    </FlowPlayerControls>
  );
}

export default ReferenceCheckStepView;